define('lq/licquidRuntimeMpa',[
    'underscore',
    'drops/action/action',
    'lq/runtimePiping',
    'lq/style',
    'lq/windowSize',
    'lq/navigatorMpa',
    'lq/responsive',
    'lq/layouting',
    'lq/services/mpa/serviceFactory',
    'lq/validatorGateway',
    'lq/javascript/polyfill',
], function (_, Action, RuntimePiping, Style, windowSize, NavigatorMpa, responsive, layouting, serviceFactory, validatorGateway) {

    var inIframe = function() {
        return window !== window.parent;
    };

    var LicquidRuntimeMpa = function () {
        if (window.cordova) {
            document.addEventListener('deviceready', function () {
                if (window.universalLinks) {
                    window.universalLinks.subscribe(null, function (eventData) {
                        window.location = eventData.url;
                    });
                }
            }, false);
        }
    };
    
    LicquidRuntimeMpa.prototype.start = function (setup) {
        Style.defaultStyles = setup.application.styles.defaultStyles;
        Style.defaultMockStyles = setup.application.styles.defaultMockStyles;
        Style.mockMode = setup.isInMockMode;

        var $app = setup.$el;
        var $wrapper = $('<div class="licquid-action-wrapper" />')
            .appendTo($app);
        var $view = $('<div class="licquid-action-view" />')
            .appendTo($wrapper);

        this.globalPiping = RuntimePiping.createRoot(setup.parameters.globals, setup.application, $app);
        this.globalPiping.navigator = new NavigatorMpa(this.globalPiping.url, setup.friendlyNames);
        this.globalPiping.errorHandler.addListener(this.handleError.bind(this));
        
        var action = new Action(setup.action.view, setup.application.options);
        action.backgroundDrops = setup.action.backgroundDrops;
        action.allLayouts = setup.action.allLayouts;
        action.defaultLayout = setup.action.defaultLayout;
        action.piping = this.globalPiping.createChildPiping(setup.action, action, setup.parameters.locals, setup.parameters.system, $wrapper, $view, window.performance.navigation.type == window.performance.navigation.TYPE_RELOAD);

        var self = this;

        if (validatorGateway.isEnabled()) {
            validatorGateway.publishEvent({
                type: 'LICQUID_RUNTIME_LOADED',
                globalPiping: this.globalPiping
            });
        } else {
            validatorGateway.whenEnabled(function () {
                validatorGateway.publishEvent({
                    type: 'LICQUID_RUNTIME_LOADED',
                    globalPiping: self.globalPiping
                });

                if (self.action !== null) {
                    validatorGateway.registerListener(self.action.instanceId, self.receiveMessage.bind(self));

                    validatorGateway.publishEvent({
                        type: 'ACTION_INSTANCE_LOADED',
                        action: self.action,
                        canReload: false
                    });
                }
            });
        }

        action.services = _.map(setup.application.services.concat(setup.action.services), function (service) {
            return serviceFactory.createService(service, action);
        });

        var layout = responsive.getCurrentLayout(action);
        layouting.applyLayout($view, layout);

        var notInsideIFrame = window.top.location === window.location;
        action.applyLayout(layout, notInsideIFrame);

        if (action.shouldUseWidthOfLayout()) {
            action.data.size.x = layout.resolutionX;
        }

        // note: only the top level action should update the viewport
        action.createAndRenderDrops($('#viewport'))
            .then(function () {
                return action.startEventing();
            });
        
        if (setup.application.embedded) {
            window.parent.postMessage(JSON.stringify({
                eventName: 'LicquidLoaded'
            }), '*');
        }
        
        if (validatorGateway.isEnabled()) {
            validatorGateway.registerListener(action.instanceId.toString(), this.receiveMessage.bind(this));

            validatorGateway.publishEvent({
                type: 'ACTION_INSTANCE_LOADED',
                action: action,
                canReload: false
            });
        }

        if (inIframe()) {
            window.parent.postMessage(JSON.stringify({
                eventName: 'EmbeddedActionLoaded',
                sizeX: action.data.size.x,
                sizeY: action.data.size.y
            }), window.location.protocol + '//' + window.location.host);
            
            var receiveMessage = function (e) {
                if (e.source !== window.parent)
                    return;
                try {
                    var eventObj = JSON.parse(e.data);
                    if (!eventObj.eventName)
                        return;
                    action.triggerEvent(eventObj.eventName, eventObj.args[0]);
                } catch (err) {
                    //could not parse, ignore it
                }
            };

            window.addEventListener("message", receiveMessage, false);
        }

        windowSize.withOnChanged(function () {
            action.resize();
        });

        this.action = action;
    };

    LicquidRuntimeMpa.prototype.receiveMessage = function (message) {
        switch (message.type) {

            case 'RELOAD_ACTION_INSTANCE':
                this.openNewAction(this.action.data.id, this.action.globals, this.action.locals, { ignoreHistory: true });
                break;

            case 'HIGHLIGHT_ACTION_INSTANCE':
                highlighter.highlight(this.$wrapper);
                break;

        }
    };

    LicquidRuntimeMpa.prototype.handleError = function (errorArgs) {
        if (this.action) this.action.error(errorArgs);
    };

    return LicquidRuntimeMpa;
});
